import varAxios from "../../Comman/axios";
import {UpdateReportTypeSetting,GenerateMonthlyReportExcel,GenerateMonthlyReportByRegionId,GetMonthlyReportUrl,GetRegionListUrl, GetUserListUrl,GetAlarmReportUrl} from '../../Comman/apiEndPoints';


import swal from 'sweetalert';
export const Fetch_All_Region_Data1 = "Fetch_All_Region_Data1";
export const Fetch_All_Users_Data = "Fetch_All_Users_Data";
export const Fetch_All_Alarm_Data = "Fetch_All_Alarm_Data";
export const Fetch_All_Monthly_Report_Data = "Fetch_All_Monthly_Report_Data";
export function notify(message){
        swal({ text : message, icon : 'success' })
}

export function getAllMonthlyReport(formData) {
  return (dispatch) => {
     
      return varAxios.post(GetMonthlyReportUrl, formData,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            dispatch(
            fetchAllMonthlyReportData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              lifeGuardAlarm : response.data.lifeGuardAlarm
             }));
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function fetchAllMonthlyReportData({errorCode, statusCode, lifeGuardAlarm}) {
  return {
    type : Fetch_All_Monthly_Report_Data,
    errorCode,
    statusCode,
    lifeGuardAlarm
  }
}
export function getAllRegionSettings() {
     let requestPayload={
    UserId:sessionStorage.getItem('SuperAdminUserID')
  }
    return(dispatch) =>{
       return varAxios.post(GetRegionListUrl,requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
        let date = new Date()
        let firstDay = new Date(date.getFullYear(), date.getMonth(), 2).toISOString();
        let value =firstDay.split('T');

        let Currentdate = new Date().toISOString();
        
        let Currentvalue =Currentdate.split('T');
       
        this.getAllMonthlyReport({RegionId:response.data.regionList[0].ID,FromDate:value[0],ToDate:Currentvalue[0],IsAllRegion:false})
          dispatch(
            fetchAllRegionData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              regionList : response.data.regionList
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllRegionData({errorCode, statusCode, regionList}) {
  return {
    type : Fetch_All_Region_Data1,
    errorCode,
    statusCode,
    regionList
  }
}
export function getAllUsers(formData) {
  return (dispatch) => {
     
      return varAxios.post(GetUserListUrl, formData,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            dispatch(
            fetchAllUsersData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              usersList : response.data.lifeGuards
             }));
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function fetchAllUsersData({errorCode, statusCode, usersList}) {
  return {
    type : Fetch_All_Users_Data,
    errorCode,
    statusCode,
    usersList
  }
}
export function getAllAlarm(formData) {
  return (dispatch) => {
     
      return varAxios.post(GetAlarmReportUrl, formData,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            dispatch(
            fetchAllAlarmData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              alarmList : response.data.alarmReports
             }));
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function PerRegionPdfMail(data) {
  return (dispatch) => {
    
      return varAxios.post(GenerateMonthlyReportByRegionId,data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
              
              if(response.data.statusCode)
              {
                notify(response.data.errorMessage)
              }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function fetchAllAlarmData({errorCode, statusCode, alarmList}) {
  return {
    type : Fetch_All_Alarm_Data,
    errorCode,
    statusCode,
    alarmList
  }
}

export function PerRegionExcelMail(data) {
  return (dispatch) => {
    
      return varAxios.post(GenerateMonthlyReportExcel,data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
              
              if(response.data.statusCode)
              {
                notify(response.data.errorMessage)
              }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function UpdateReportTypeSettings(data) {
  return (dispatch) => {
    
      return varAxios.post(UpdateReportTypeSetting,data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
              
              if(response.data.statusCode)
              {
                notify(response.data.errorMessage)
              }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
